import { useQuery } from "@tanstack/react-query";
import { ACCESSIBLE_ACCOUNTS } from "../../constants/QueryKeys";
import UserService from "../../service/UserService";

/** @typedef {import("@/types/data/Account.mjs").AccessibleAccount} AccessibleAccount */
/**
 * @template T
 * @typedef {import("@/types/TypeUtils.mjs").QueryResultRest<T>} QueryResultRest
 */
/**
 * @template T
 * @typedef {import("@/types/TypeUtils.mjs").QueryHookOptions<T>} QueryHookOptions
 */

const defaults = {
  retry: false,
};

/**
 * The accounts the user can switch into, sorted by owner name.
 * @param {QueryHookOptions<AccessibleAccount[]>} [options] - Extra `useQuery` options, spread over the defaults.
 * @returns {{ accessibleAccounts: AccessibleAccount[] } & QueryResultRest<AccessibleAccount[]>}
 */
const useAccessibleAccounts = (options = {}) => {
  const { data = [], ...rest } = useQuery({
    queryKey: [ACCESSIBLE_ACCOUNTS],
    queryFn: () =>
      /** @type {Promise<AccessibleAccount[]>} */ (UserService.getAccessibleAccounts()),
    ...defaults,
    ...options,
  });
  return {
    accessibleAccounts: data.sort((a, b) =>
      a.ownerName < b.ownerName ? -1 : a.ownerName > b.ownerName ? 1 : 0,
    ),
    ...rest,
  };
};

export default useAccessibleAccounts;
